import ajax from "./util-ajax";

const jQuery = window.jQuery;

const ajaxSave = {
  saveCampaign: saveCampaign,
  saveElement: saveElement,
  updateElementsForPod: updateElementsForPod,
  saveException: saveException,
  saveFileToS3: saveFileToS3,
  saveInvite: saveInvite,
  savePod: savePod,
  savePodToCampaign: savePodToCampaign,
  saveSpotsToPod: saveSpotsToPod,
  saveSpot: saveSpot,
  saveRule: saveRule,
  saveRuleAsExpired: saveRuleAsExpired,
  saveStation: saveStation,
  savePodNotification: savePodNotification,
  saveInvoiceCustomizations: saveInvoiceCustomizations
};

export default ajaxSave;

//

function saveCampaign(campaignId, report) {
  return jQuery.ajax({
    beforeSend: ajax.beforeSend,
    contentType: ajax.contentType,
    data: JSON.stringify(report),
    method: campaignId === 0 ? `post` : `put`,
    url: campaignId === 0 ? `/api/campaigns/` : `/api/campaigns/${campaignId}/`
  });
}

function saveElement(elementId, report) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      data: JSON.stringify(report),
      method: elementId === 0 ? `post` : `put`,
      url:
        elementId === 0
          ? `/api/pods/elements/`
          : `/api/pods/elements/${elementId}/`
    })
    .fail(ajax.onFail);
}

function updateElementsForPod(podId, report) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      data: JSON.stringify(report),
      method: `post`,
      url: `/api/pods/${podId}/elements/`
    })
    .fail(ajax.onFail);
}

function saveException(ruleId, report) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      data: JSON.stringify(report),
      method: `post`,
      url: `/api/conflicts/${ruleId}/`
    })
    .fail(ajax.onFail);
}

function saveFileToS3(report, url, progressCallback) {
  return jQuery
    .ajax({
      beforeSend: request => {
        request.setRequestHeader(`x-amz-acl`, `public-read`);
        request.setRequestHeader(
          `X-CSRFToken`,
          ajax.getCookie(ajax.crossSiteProtectionCookieName)
        );
      },
      xhr: progressCallback,
      contentType: false,
      data: report,
      method: `post`,
      processData: false,
      url: url
    })
    .fail(ajax.onFail);
}

function saveInvite(inviteId, report) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      data: JSON.stringify(report),
      method: inviteId === 0 ? `post` : `put`,
      url:
        inviteId === 0
          ? `/api/station/invites/`
          : `/api/station/invites/${inviteId}/`
    })
    .fail(ajax.onFail);
}

function savePod(podId, report) {
  return jQuery.ajax({
    beforeSend: ajax.beforeSend,
    contentType: ajax.contentType,
    data: JSON.stringify(report),
    method: podId === 0 ? `post` : `put`,
    url: podId === 0 ? `/api/pods/` : `/api/pods/${podId}/`
  });
}

function saveSpotsToPod(podId, spotIds) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      data: JSON.stringify({
        spot_ids: spotIds
      }),
      method: `post`,
      url: `/api/pods/${podId}/spots/`
    })
    .fail(ajax.onFail);
}

function savePodToCampaign(campaignId, podId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      data: JSON.stringify({
        pod_id: podId
      }),
      method: `post`,
      url: `/api/campaigns/${campaignId}/pods/`
    })
    .fail(ajax.onFail);
}

function saveSpot(spotId, report) {
  return jQuery.ajax({
    beforeSend: ajax.beforeSend,
    contentType: ajax.contentType,
    data: JSON.stringify(report),
    method: spotId === 0 ? `post` : `put`,
    url: spotId === 0 ? `/api/spots/` : `/api/spots/${spotId}/`
  });
}

function saveRule(ruleId, report) {
  return jQuery.ajax({
    beforeSend: ajax.beforeSend,
    contentType: ajax.contentType,
    data: JSON.stringify(report),
    method: ruleId === 0 ? `post` : `put`,
    url: ruleId === 0 ? `/api/rules/` : `/api/rules/${ruleId}/`
  });
}

function saveRuleAsExpired(ruleId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      method: `post`,
      url: `/api/rules/${ruleId}/expire/`
    })
    .fail(ajax.onFail);
}

function saveStation(stationId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      data: JSON.stringify({
        station_id: stationId
      }),
      method: `put`,
      url: `/api/user/change-station/`
    })
    .fail(ajax.onFailWithExceptions);
}

function savePodNotification(podId, notificationStatus, podNotificationId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      data: podNotificationId
        ? JSON.stringify({
            aws_transcode_notification_seen: notificationStatus
          })
        : JSON.stringify({
            pod: podId,
            aws_transcode_notification_seen: notificationStatus
          }),
      method: podNotificationId ? `patch` : `post`,
      url: podNotificationId
        ? `/api/pods/notifications/${podNotificationId}/`
        : `/api/pods/notifications/`
    })
    .fail(ajax.onFail);
}

function saveInvoiceCustomizations(customizations, customizationsId) {
  return jQuery
    .ajax({
      beforeSend: ajax.beforeSend,
      contentType: ajax.contentType,
      data: JSON.stringify(customizations),
      method: customizationsId === 0 ? `post` : `put`,
      url:
        customizationsId === 0
          ? `/api/reports/station-customizations/`
          : `/api/reports/station-customizations/${customizationsId}/`
    })
    .fail(ajax.onFail);
}
